<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <section class="cart-module">
    <!-- Retail Interstitial Modal -->
    <Teleport to="body">
      <div v-if="showRetailModal" class="retail-modal-overlay" @click.self="closeRetailModal">
        <div class="retail-modal">
          <div class="retail-modal__header">
            <h2 class="retail-modal__title">Shop ORE Products<br>with our Retail Partner</h2>
          </div>
          <div class="retail-modal__body">
            <div class="retail-modal__col">
              <p class="retail-modal__body-primary">Homeowners and private buyers can purchase our standard collections instantly through our verified retail partner.</p>
              <p class="retail-modal__body-note">(Please note: Items currently in your ORE cart will not transfer)</p>
              <a
                href="https://www.uniquegardendecor.com/ore-landing-page/?utm_source=ore_design&utm_medium=partner_redirect&utm_campaign=retail_purchasing&utm_content=quote_page"
                target="_blank"
                rel="noopener"
                class="retail-modal__btn retail-modal__btn--primary"
              >Continue to Partner</a>
            </div>
            <div class="retail-modal__col">
              <p class="retail-modal__body-secondary">Trade professionals requiring commercial pricing and custom specifications please return and fill out a quote request.</p>
              <button
                type="button"
                class="retail-modal__btn retail-modal__btn--secondary"
                @click="closeRetailModal"
              >Request a Quote</button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <div class="cart-inner-container">
      <FormKit
        type="form"
        id="formKit"
        #default="{ value, state: { valid } }"
        :plugins="[stepPlugin]"
        @submit="submitHandler"
        @submit-invalid="showErrors"
        :actions="false"
      >
        <!-- content -->
        <!-- cart -->
        <div>
          <!-- sticky stepper nav -->
          <div class="steps-container" ref="stepsContainer">
            <ul class="steps">
              <li
                v-for="(section, sIndex) in sectionLabels"
                :key="`section-${sIndex}`"
                :class="['step', { 'is-active': currentSection === sIndex }]"
                @click="scrollToSection(sIndex)"
                :data-step-valid="true"
                :data-step-active="currentSection === sIndex"
              >
                <span
                  class="step-number"
                  v-text="`0${sIndex + 1}`"
                />
                {{ section }}
              </li>
            </ul>
            <div class="next">
              <div class="flex items-center gap-2">
                <button
                  type="button"
                  class="formkit-input"
                  :disabled="!valid || disabled"
                  @click="handleSubmitClick"
                >{{ labelSend }}</button>
              </div>
            </div>
          </div>
          <div class="main-container cart-container">
            <div v-if="!hasItems" class="empty-quote-intro">
              <h2 class="text-3xl lg:text-[60px] mt-20 mb-10 text-ore_green font-medium">Request a Quote</h2>
              <div class="section-group">
                <h3 class="section-heading">Add Items to Your Quote</h3>
                <p class="intro-text">Browse our products and finish samples to include with your quote, or fill out the form below for a custom project inquiry.</p>
                <div class="prompt-cards">
                  <a class="prompt-card prompt-card--accent" @click.prevent="router.push('/pre-designed/')">
                    <span class="prompt-card-icon">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
                    </span>
                    <span class="prompt-card-title">Commercial Purchasing</span>
                    <span class="prompt-card-subtitle">Request a quote for pre-designed products</span>
                    <span class="prompt-card-arrow">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                    </span>
                  </a>
                  <a class="prompt-card prompt-card--accent" @click.prevent="router.push('/finishes/')">
                    <span class="prompt-card-icon">
                      <!-- Paintbrush icon -->
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18.37 2.63 14 7l-1.59-1.59a2 2 0 0 0-2.82 0L8 7l9 9 1.59-1.59a2 2 0 0 0 0-2.82L17 10l4.37-4.37a2.12 2.12 0 1 0-3-3Z"/><path d="M9 8c-2 3-4 3.5-7 4l8 10c2-1 6-5 6-7"/><path d="M14.5 17.5 4.5 15"/></svg>
                    </span>
                    <span class="prompt-card-title">Colors & Finishes</span>
                    <span class="prompt-card-subtitle">Order finish samples for your project</span>
                    <span class="prompt-card-arrow">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                    </span>
                  </a>
                  <a class="prompt-card prompt-card--accent" @click.prevent="scrollToContact">
                    <span class="prompt-card-icon">
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"/><path d="M14 2v6h6"/><path d="M16 13H8"/><path d="M16 17H8"/><path d="M10 9H8"/></svg>
                    </span>
                    <span class="prompt-card-title">Custom Project Inquiry</span>
                    <span class="prompt-card-subtitle">Fill out the form for a custom quote</span>
                    <span class="prompt-card-arrow">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                    </span>
                  </a>
                  <a class="prompt-card" @click.prevent="openRetailModal">
                    <span class="prompt-card-icon">
                      <!-- Shopping bag / retail icon -->
                      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
                    </span>
                    <span class="prompt-card-title">Retail Purchasing</span>
                    <span class="prompt-card-subtitle">Not in the trade? Buy now.</span>
                    <span class="prompt-card-arrow">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <!-- Section 1: Products -->
            <div v-if="hasItems" id="section-products" ref="sectionProducts">
              <h2 class="text-3xl lg:text-[60px] mt-20 mb-10 text-ore_green font-medium">Products</h2>
              <CartCard  v-for="(item, index) of cart" :key="`${index}-cart-card`" :data="item" :index="index" />
              <div v-if="cart.length === 0" class="inline-prompt">
                <a class="prompt-card" @click.prevent="router.push('/pre-designed/')">
                  <span class="prompt-card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>
                  </span>
                  <div class="prompt-card-text">
                    <span class="prompt-card-title">Add Pre-Designed Products</span>
                    <span class="prompt-card-subtitle">Browse our ready-to-order collection</span>
                  </div>
                  <span class="prompt-card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                  </span>
                </a>
              </div>
            </div>
            <!-- Finish Samples (grouped with Products) -->
            <div v-if="hasItems" class="finish-samples-section">
              <div class="flex gap-5 flex-wrap">
                <CartFinishCard v-for="(finish, index) of finishes" :key="`${index}-cart-card`" :finish="finish.finish" :category="finish.finishId"  />
              </div>
              <div v-if="finishes.length === 0" class="inline-prompt">
                <a class="prompt-card" @click.prevent="router.push('/finishes/')">
                  <span class="prompt-card-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1"/></svg>
                  </span>
                  <div class="prompt-card-text">
                    <span class="prompt-card-title">Add Finish Samples</span>
                    <span class="prompt-card-subtitle">Order finish samples for your project</span>
                  </div>
                  <span class="prompt-card-arrow">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                  </span>
                </a>
              </div>
            </div>
            <!-- Retail partner banner (shown when items in cart) -->
            <div v-if="hasItems" class="retail-banner">
              <span class="retail-banner__text">
                <strong>Not a Trade Professional?</strong> Purchase your items instantly through our exclusive retail partner.
              </span>
              <a class="retail-banner__link" @click.prevent="openRetailModal" href="#">Shop Now</a>
            </div>

            <!-- Section 2 & 3: Form fields (Contact & Project sections rendered via schema) -->
            <div class="form-body" v-if="isDataFormLoaded">
              <div class="step-content-container">
                <div
                  class="step-content"
                  v-for="(step, index) in props.data.steps_names"
                  :key="`step-content-${index}`"
                  >
                  <ul class="validation-errors" v-if="messages.length">
                    <li v-for="(message, indexMessage) in messages" :key="`message-${indexMessage}`">
                      {{ message }}
                    </li>
                  </ul>
                  <FormKit
                    :id="step.step_name"
                    type="group"
                    :name="step.step_name"
                    v-model="requestFormData"
                  >
                    <FormKitSchema :schema="formByPage[index]" :data="requestFormData"/>
                  </FormKit>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FormKit>
    </div>
  </section>
</template>
<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount, ref, computed } from 'vue'
import Button from '@/components/utility/Button.vue'
import { useStore } from 'vuex'
import { cartState } from './Store.js'
import { finishState } from './finishStore.js'
import { useRouter } from 'vue-router'
import { reset, getNode } from '@formkit/core'
import { getValidationMessages } from '@formkit/validation'
import Axios from 'axios'
import camel2title from '../../../utils/utils'
import useSteps from '../../../utils/useSteps'
import CartCard from './CartCard.vue'
import CartFinishCard from './CartFinishCard.vue'
import { useDecimalToInches } from '@/composables/useDecimalToInches.js'

const props = defineProps(['data'])
const { steps, visitedSteps, activeStep, setStep, stepPlugin } = useSteps()
const store = useStore()
const router = useRouter()
const form = ref({})
const formByPage = ref({})
const storeParams = ref({})
const requestFormData = ref({})
const messages = ref([])
const activeIndex = ref(1)
const isDataFormLoaded = ref(false)
const disabled = ref(false)
const labelSend = ref('Submit')
const quoteForm = store._state.data.quote_form
const { cart, clearCart } = cartState()
const { finishes, clearFinishes } = finishState()

const hasItems = computed(() => cart.value.length > 0 || finishes.value.length > 0)

// Retail interstitial modal
const showRetailModal = ref(false)

const openRetailModal = () => { showRetailModal.value = true }
const closeRetailModal = () => { showRetailModal.value = false }


const COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda',
  'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain',
  'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
  'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria',
  'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada',
  'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros',
  'Congo', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic',
  'Democratic Republic of the Congo', 'Denmark', 'Djibouti', 'Dominica',
  'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea',
  'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France',
  'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada',
  'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary',
  'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy',
  'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait',
  'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya',
  'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia',
  'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius',
  'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco',
  'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand',
  'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway',
  'Oman', 'Pakistan', 'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay',
  'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia',
  'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia',
  'Saint Vincent and the Grenadines', 'Samoa', 'San Marino',
  'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
  'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia',
  'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan',
  'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania',
  'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia',
  'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates',
  'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu',
  'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
]

// Section navigation
const sectionLabels = computed(() => {
  if (hasItems.value) {
    return ['Products & Samples', 'Contact Information', 'Project Information']
  }
  return ['Contact Information', 'Project Information']
})
const currentSection = ref(0)
const sectionProducts = ref(null)
const stepsContainer = ref(null)

const getSectionElements = () => {
  if (hasItems.value) {
    return [
      sectionProducts.value,
      document.getElementById('section-contact-fields'),
      document.getElementById('section-project-fields')
    ]
  }
  return [
    document.getElementById('section-contact-fields'),
    document.getElementById('section-project-fields')
  ]
}

const scrollToSection = (index) => {
  const sections = getSectionElements()
  const el = sections[index]
  if (el) {
    const navHeight = stepsContainer.value?.offsetHeight || 80
    const headerOffset = 70
    const top = el.getBoundingClientRect().top + window.scrollY - navHeight - headerOffset - 10
    window.scrollTo({ top, behavior: 'smooth' })
  }
}

const scrollToContact = () => {
  const el = document.getElementById('section-contact-fields')
  if (el) {
    const navHeight = stepsContainer.value?.offsetHeight || 80
    const headerOffset = 70
    const top = el.getBoundingClientRect().top + window.scrollY - navHeight - headerOffset - 10
    window.scrollTo({ top, behavior: 'smooth' })
  }
}

const updateCurrentSection = () => {
  const sections = getSectionElements()
  const navHeight = (stepsContainer.value?.offsetHeight || 80) + 70 + 40
  for (let i = sections.length - 1; i >= 0; i--) {
    if (sections[i]) {
      const rect = sections[i].getBoundingClientRect()
      if (rect.top <= navHeight) {
        currentSection.value = i
        return
      }
    }
  }
  currentSection.value = 0
}

let scrollHandler = null

onMounted(() => {
  scrollHandler = () => updateCurrentSection()
  window.addEventListener('scroll', scrollHandler, { passive: true })
})

onBeforeUnmount(() => {
  if (scrollHandler) {
    window.removeEventListener('scroll', scrollHandler)
  }
})

const showErrors = (node) => {
  messages.value = []
  const validations = getValidationMessages(node)
  validations.forEach((inputMessages) => {
    messages.value = messages.value.concat(
      inputMessages.map((message) => message.value)
    )
  })
  console.log(messages.value)
}

const handleSubmitClick = async () => {
  if (disabled.value) return
  try {
    await submitHandler(requestFormData.value, getNode('formKit'))
  } catch (e) {
    console.error('Submit error:', e)
    disabled.value = false
    labelSend.value = 'Submit'
  }
}

const returnBack = () => {
  if (props.data.return_link.url) {
    const url = props.data.return_link.url.replace(store.state.site.url, '')
    router.push(url)
  } else {
    router.push('/')
  }
}
const postData = async (URL, body, node) => {
  try {
    const response = await Axios.post(URL, body, {
      headers: {
        'Content-Type': 'multipart/form-data',
        withCredentials: true
      }
    })
    disabled.value = false
    labelSend.value = 'Submit'
    messages.value = []
    if (response.status === 200 && response.data.is_valid) {
      if (node) node.clearErrors()
      reset('formKit')
      const path = props.data.thank_you_page_url.url.replace(store._state.data.site.url, '')
      router.push(path)
    }
  } catch (error) {
    disabled.value = false
    labelSend.value = 'Submit'
    if (node) node.setErrors(error.formErrors, error.fieldErrors)
    console.error(`There was an error submitting the form: ${error}`)
  }
}

const navigateThankYou = async () => {
  await router.push(props.data.thank_you_page_url.url.replace(store._state.data.site.url, ''))
  clearCart()
  clearFinishes()
}

// NEW POSTING METHOD
// Add Quote Products to Gravity forms
const addToGFQuote = (cart) => {
  const data = cart.value.map((x) => {
    // console.log(x)
    return {
      image: x.currentImage,
      product: x.product.title.rendered,
      finish: `${x.finishCategory} - ${x.finish['acf-single-product-options-finish-option'].label}`,
      size: x.size.attributes.attribute_size,
      options: (x.designOptions || []).map((option) => ` ${option.label}`),
      length: useDecimalToInches(x.size.dimensions.length).toRegularString(),
      width: useDecimalToInches(x.size.dimensions.width).toRegularString(),
      height: useDecimalToInches(x.size.dimensions.height).toRegularString(),
      diameter: useDecimalToInches(x.size?.diameter).toRegularString() || '',
      quantity: x.quantity
    }
  })
  return data
}

const addFinishToGFQuote = (cart) => {
  const data = finishes.value.map((x) => {
    return {
      image: x.finish['acf-product-options-finish-image'].url,
      finish: x.finishId
    }
  })
  return data
}

const submitHandler = async (_data, node) => {
  disabled.value = true
  labelSend.value = 'Sending...'
  messages.value = []
  const curedForm = new FormData()
  const requestFormDataHelper = { ...requestFormData.value }
  if ('slots' in requestFormDataHelper) {
    delete requestFormDataHelper.slots
  }
  const keys = Object.keys(requestFormDataHelper)
  keys.forEach(element => {
    if (element === 'Finish request') {
      const formElement = form.value.fields.find((x) => x.label === 'Finish request')
      addFinishToGFQuote(cart).forEach((x) => {
        for (const prop in x) {
          curedForm.append(`input_${formElement.id}[]`, x[prop])
        }
      })
      return
    }
    if (element === 'Product list') {
      // console.log(form.value)
      const formElement = form.value.fields.find((x) => x.label === 'Product list')
      addToGFQuote(cart).forEach((x) => {
        for (const prop in x) {
          curedForm.append(`input_${formElement.id}[]`, x[prop])
        }
      })
      return
    }
    if (requestFormDataHelper[element] === undefined) {
      return
    }
    const fieldSettings = form.value.fields.find((x) => {
      const result = x.type === 'checkbox' ? element.replaceAll('_', ' ') : element
      return x.label === result
    })
    if (fieldSettings.type === 'address' || fieldSettings.type === 'name') {
      requestFormDataHelper[element].forEach((subElement, indexSubElement) => {
        curedForm.append(`input_${fieldSettings.inputs[indexSubElement].id.replace('.', '_')}`, subElement ?? '')
      })
    } else if (fieldSettings.type === 'checkbox') {
      curedForm.append(`input_${fieldSettings.id}_1`, requestFormDataHelper[element] ? fieldSettings.label : '')
    } else if (fieldSettings.type === 'date') {
      let result = ''
      if (requestFormDataHelper[element]) {
        const date = requestFormDataHelper[element]
        const [year, month, day] = date.split('-')
        result = [month, day, year].join('/')
      }
      curedForm.append(`input_${fieldSettings.id}`, result)
    } else {
      curedForm.append(`input_${fieldSettings.id}`, fieldSettings.type === 'fileupload' ? requestFormDataHelper[element].map(a => a.file)[0] ?? '' : requestFormDataHelper[element] ?? '')
    }
  })

  // await addToYITHQuote(cart)
  await postData(form.value.submitURL, curedForm, node)
  // await Axios.get(`${store._state.data.site.url}/wp-json/wp/v2/clear-quote`)
  navigateThankYou()
}

const checkStepValidity = (stepName) => {
  console.log(stepName)
  return (steps[stepName].errorCount > 0 || steps[stepName].blockingCount > 0) && visitedSteps.value.includes(stepName)
}

const selectOptions = (choices) => {
  if (choices) {
    return choices.map((choice) => {
      return choice.text
    })
  } else {
    return []
  }
}

const validationTypes = (required, type) => {
  const validation = []
  if (required) {
    validation.push('required')
  }
  if (type === 'email') {
    validation.push('email')
  }
  if (type === 'phone') {
    validation.push('number')
    validation.push('length:10,10')
  }
  const finalValidation = validation.join('|')
  return finalValidation
}

const returnFormKiType = (type) => {
  switch (type) {
    case 'phone':
      return 'tel'
    case 'fileupload':
      return 'file'
    case 'address':
    case 'name':
    case 'checkbox':
      return 'list'
    default:
      return type
  }
}

const buildFieldSettings = (field) => {
  const validations = validationTypes(field.isRequired, field.type)
  let fieldSettings = {
    $formkit: returnFormKiType(field.type),
    name: field.label,
    label: field.labelPlacement ? '' : field.label,
    placeholder: field.placeholder,
    validation: validations,
    outerClass: field.cssClass,
    validationVisibility: 'blur'
  }

  if (field.conditionalLogic && field.conditionalLogic?.rules.length > 0) {
    fieldSettings.if = `$${field.conditionalLogic.rules[0].value.replaceAll(' ', '_')} !== true`
  }

  if (field.type === 'select') {
    fieldSettings.options = selectOptions(field.choices)
  }
  if (field.type === 'textarea') {
    fieldSettings.rows = 4
  }
  if (field.type === 'fileupload') {
    fieldSettings.accept = field.allowedExtensions ?? ''
    fieldSettings.multiple = false
  }
  if (field.type === 'address' || field.type === 'name') {
    const children = []
    if (field.labelPlacement.length === 0) {
      children.push({
        $el: 'div',
        attrs: { class: 'formkit-outer always-full' },
        children: [{
          $el: 'div',
          attrs: { class: 'formkit-wrapper' },
          children: [{
            $el: 'label',
            attrs: { class: 'formkit-label' },
            children: field.label || field.placeholder
          }]
        }]
      })
    }
    field.inputs.forEach(element => {
      const isCountry = element.label === 'Country'
      const fieldType = element.isHidden ? 'hidden' : isCountry ? 'select' : 'text'

      const child = {
        $formkit: fieldType,
        name: element.label,
        label: field.subLabelPlacement === 'hidden_label' ? '' : element.customLabel !== '' ? element.customLabel : element.label,
        placeholder: element.placeholder,
        validation: element.isHidden ? [] : element.label === 'ZIP / Postal Code' ? validationTypes(field.isRequired, 'zipcode') : validations,
        validationLabel: element.placeholder !== '' ? element.placeholder : element.customLabel !== '' ? element.customLabel : element.label,
        outerClass: 'half-width',
        autoComplete: element.placeholder
      }

      if (isCountry) {
        child.options = COUNTRIES
        child.value = 'United States'
      }

      children.push(child)
    })
    fieldSettings.children = children
  }

  if (field.type === 'checkbox') {
    fieldSettings = {}
    fieldSettings.$formkit = 'checkbox'
    fieldSettings.name = (field.choices[0].value).replaceAll(' ', '_')
    fieldSettings.label = field.choices[0].text
    fieldSettings.value = true
  }

  return fieldSettings
}

const isContactField = (field) => {
  const contactTypes = ['name', 'email', 'phone', 'address']
  if (contactTypes.includes(field.type)) return true
  if (field.label && field.label.toLowerCase().includes('company')) return true
  if (field.type === 'checkbox') return true
  return false
}

const setFormByPage = () => {
  const schema = [[{
    $formkit: 'hidden',
    name: 'hidden',
    type: 'hidden'
  }]]

  const personalFields = []   // name, email, phone, company
  const shippingFields = []   // shipping address
  const addressToggle = []    // "same as" checkbox
  const billingFields = []    // billing address (conditional)
  const projectFields = []    // everything else

  form.value.fields.forEach((field) => {
    if (field.type === 'page') return

    const fieldSettings = buildFieldSettings(field)

    // Override display label for "Street Address" → "Billing Address"
    if (field.type === 'address' && field.label === 'Street Address') {
      // Find and update the label div in children (first child is the label wrapper)
      if (fieldSettings.children && fieldSettings.children.length > 0) {
        const labelWrapper = fieldSettings.children[0]
        if (labelWrapper.$el === 'div' && labelWrapper.children) {
          const innerWrapper = labelWrapper.children[0]
          if (innerWrapper && innerWrapper.children) {
            const labelEl = innerWrapper.children[0]
            if (labelEl && labelEl.$el === 'label') {
              labelEl.children = 'Billing Address'
            }
          }
        }
      }
    }

    // Override checkbox display label
    if (field.type === 'checkbox' && field.label.toLowerCase().includes('same as street')) {
      fieldSettings.label = 'Shipping Address is the same as Billing Address'
    }

    // Categorize into groups for correct ordering
    if (field.type === 'address' && field.label === 'Shipping Address') {
      shippingFields.push(fieldSettings)
    } else if (field.type === 'address' && field.label === 'Street Address') {
      billingFields.push(fieldSettings)
    } else if (field.type === 'checkbox' && field.label.toLowerCase().includes('same as')) {
      addressToggle.push(fieldSettings)
    } else if (isContactField(field)) {
      personalFields.push(fieldSettings)
    } else {
      projectFields.push(fieldSettings)
    }
  })

  // Order: personal info → shipping address → checkbox → billing address
  const allContactFields = [...personalFields, ...shippingFields, ...addressToggle, ...billingFields]

  schema[1] = [
    {
      $el: 'div',
      attrs: { id: 'section-contact-fields', class: 'section-group' },
      children: [
        { $el: 'h3', attrs: { class: 'section-heading' }, children: 'Contact & Shipping' },
        { $el: 'div', attrs: { class: 'section-fields' }, children: allContactFields }
      ]
    }
  ]

  schema[2] = [
    {
      $el: 'div',
      attrs: { id: 'section-project-fields', class: 'section-group' },
      children: [
        { $el: 'h3', attrs: { class: 'section-heading' }, children: 'Project Details' },
        { $el: 'div', attrs: { class: 'section-fields' }, children: projectFields }
      ]
    }
  ]

  return schema
}

const getFormData = async () => {
  storeParams.value = {
    type: 'forms',
    id: quoteForm.gf_id,
    showLoading: true
  }
  await store.dispatch('getSingleById', storeParams.value)
  form.value = store.getters.singleById(storeParams.value)
  // console.log(form.value)
  formByPage.value = setFormByPage()
  isDataFormLoaded.value = true
}

const refreshScrollTrigger = () => {
  setTimeout(() => {
    // ScrollTrigger.refresh()
  }, 0)
}

onBeforeMount(() => {
  getFormData()
  refreshScrollTrigger()
})

</script>
<style lang="scss" scoped>
.cart-module {
  @apply wide-container bg-ore_mint_30 pt-48 pb-60 lg:px-14;
  .steps-container {
    @apply flex flex-col lg:flex-row items-center justify-between gap-y-2 bg-ore_green text-ore_mint_30 font-FHOscar font-normal text-2xl leading-6 px-[22px] lg:px-7 py-[15px] lg:py-5 rounded-[20px] mb-10;
    position: sticky;
    top: 70px;
    z-index: 9;

    .steps {
      @apply w-full flex flex-col lg:flex-row items-start justify-center lg:items-center;

      .step {
        @apply flex flex-col text-2xl leading-6 font-FHOscar font-normal text-ore_mint_30 lg:border-r lg:border-ore_orange lg:px-[61px] cursor-pointer opacity-60 transition-opacity duration-300;
        .step-number {
          @apply hidden lg:flex items-center lg:relative font-FHOscar font-normal text-xl leading-6 text-ore_mint;

          &::after {
            @apply bg-ore_orange w-[10px] h-[10px] rounded-[10px] absolute left-8;
            content: "";
          }
        }

        &:hover {
          @apply opacity-80;
        }
      }

      .step.is-active {
        @apply opacity-100;
      }

      .step:last-child {
        @apply border-none;
      }
    }
    .next:deep(){
      @apply flex justify-end items-center flex-shrink-0;
      .formkit-input {
        @apply bg-ore_orange text-white rounded-3xl text-[20px] leading-6 py-2 px-10 transition-all duration-500;
        filter: drop-shadow(0px 0px 30px rgba(255, 76, 0, 0.5));
      }
      .formkit-input[disabled]{
        @apply opacity-60;
      }
      &:hover{
        @apply scale-[1.025];
      }
    }
  }
  .cart-container {
    .empty-quote-intro {
      .section-group {
        @apply w-full bg-white rounded-3xl p-6 lg:p-10 mb-8;
      }
      .section-heading {
        @apply font-FHOscar font-normal text-ore_green text-xl lg:text-2xl leading-7 pb-3 mb-4 border-b border-ore_green/40;
      }
      .intro-text {
        @apply font-FHOscar font-normal text-ore_green/70 text-base lg:text-lg leading-7 mb-6;
      }
      .prompt-cards {
        @apply grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4;
      }
      .prompt-card {
        @apply flex-1 flex flex-col items-center text-center rounded-2xl p-8 lg:p-10 cursor-pointer transition-all duration-300 relative;
        background-color: #f0f5f1;

        &:hover {
          @apply shadow-lg;
          transform: translateY(-4px);
          .prompt-card-arrow {
            @apply opacity-100 translate-x-1;
          }
        }

        .prompt-card-icon {
          @apply flex items-center justify-center w-16 h-16 rounded-full bg-ore_green/10 text-ore_green mb-4;
        }
        .prompt-card-title {
          @apply font-FHOscar font-medium text-ore_green text-xl lg:text-2xl leading-7 mb-2;
        }
        .prompt-card-subtitle {
          @apply font-FHOscar font-normal text-ore_green/60 text-base leading-6 mb-4;
        }
        .prompt-card-arrow {
          @apply flex items-center justify-center w-10 h-10 rounded-full bg-ore_orange text-white opacity-80 transition-all duration-300 mt-auto;
          filter: drop-shadow(0px 0px 10px rgba(255, 76, 0, 0.3));
        }

        &--accent {
          @apply border-2 border-ore_green;
        }
      }
    }
    .retail-banner {
      @apply flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 bg-white rounded-2xl px-6 py-4 mb-6;

      &__text {
        @apply font-FHOscar text-ore_green text-base leading-6;
        strong { @apply font-medium; }
      }

      &__link {
        @apply font-FHOscar font-medium text-ore_orange text-base leading-6 whitespace-nowrap cursor-pointer;
        &:hover { @apply underline; }
      }
    }

    .finish-samples-section {
      @apply w-full bg-white rounded-3xl p-6 lg:p-10 mb-8;
    }
    .inline-prompt {
      @apply mt-4;
      .prompt-card {
        @apply flex flex-row items-center text-left rounded-2xl p-5 lg:p-6 cursor-pointer transition-all duration-300 gap-4;
        background-color: #f0f5f1;

        &:hover {
          @apply shadow-md;
          transform: translateY(-2px);
          .prompt-card-arrow {
            @apply opacity-100 translate-x-1;
          }
        }

        .prompt-card-icon {
          @apply flex items-center justify-center w-12 h-12 rounded-full bg-ore_green/10 text-ore_green flex-shrink-0;
        }
        .prompt-card-text {
          @apply flex flex-col flex-1;
        }
        .prompt-card-title {
          @apply font-FHOscar font-medium text-ore_green text-lg lg:text-xl leading-7;
        }
        .prompt-card-subtitle {
          @apply font-FHOscar font-normal text-ore_green/60 text-sm lg:text-base leading-5;
        }
        .prompt-card-arrow {
          @apply flex items-center justify-center w-9 h-9 rounded-full bg-ore_orange text-white opacity-70 transition-all duration-300 flex-shrink-0;
          filter: drop-shadow(0px 0px 8px rgba(255, 76, 0, 0.3));
        }
      }
    }
    .form-body:deep() {
      @apply flex w-full;

      .section-group {
        @apply w-full bg-white rounded-3xl p-6 lg:p-10 mb-8;
      }
      .section-heading {
        @apply font-FHOscar font-normal text-ore_green text-xl lg:text-2xl leading-7 pb-3 mb-4 border-b border-ore_green/40;
      }
      .section-fields {
        @apply flex flex-col md:flex-row md:flex-wrap w-full;

        .formkit-outer{
          @apply flex flex-col w-full lg:basis-2/4 mb-2;
          &.half-width{
            @apply basis-2/4;
          }
          &:nth-of-type(even){
            @apply md:basis-[48%] mr-[2%];
          }
          &:nth-of-type(odd), &.always-full ~ .half-width:nth-of-type(even){
            @apply lg:basis-[48%] lg:mr-[2%];
          }

          &.always-full {
            @apply md:basis-full lg:basis-full;
            .formkit-wrapper{
              @apply lg:w-[48%];
              .formkit-label {
                @apply w-1/2 lg:w-full;
              }
            }
          }
          .formkit-wrapper {
            @apply w-full flex flex-col;
            .formkit-label{
              @apply text-ore_green font-FHOscar font-normal text-base leading-7 mt-4 lg:mt-5 py-1 ml-4 lg:ml-0 border-t-0 w-auto;
            }
            .formkit-inner{
              @apply flex flex-col w-full;
                &:focus-visible, &:focus {
                --tw-ring-shadow: none;
                @apply border-none outline-none shadow-none;
              }
              .formkit-input {
                @apply flex w-full border-none text-ore_green p-3 rounded-xl font-FHOscar font-normal text-base leading-7;
                background-color: #f0f5f1;
                &:focus-visible, &:focus {
                  --tw-ring-shadow: none;
                  @apply border-none outline-none shadow-none;
                }
                &[type="date"]{
                  @apply cursor-pointer;
                }
                &[type="file"]{
                  @apply text-transparent flex items-center justify-center pl-2 leading-none;
                  &::-webkit-file-upload-button {
                    @apply invisible;
                  }
                  &::before {
                    content: "Attach File";
                    -webkit-user-select: none;
                    @apply flex items-center justify-center text-white bg-ore_orange rounded-[100px] outline-none whitespace-nowrap cursor-pointer text-base lg:text-lg py-1 px-6 lg:px-8 w-36 lg:w-44;
                  }
                }
              }
              select {
                @apply cursor-pointer;
              }
              .formkit-no-files{
                @apply pl-2;
              }
              .formkit-file-list{
                @apply flex flex-col lg:flex-row lg:flex-wrap gap-y-1 lg:gap-x-1 pl-2 lg:pl-0;
                .formkit-file-item{
                  @apply flex flex-row-reverse items-center justify-center bg-ore_green text-white rounded-[100px] text-lg lg:text-xl leading-10 py-1 lg:py-4 px-6 lg:px-20 gap-x-8 relative;
                  .formkit-file-name {
                    @apply inline-block text-ellipsis max-w-full overflow-hidden whitespace-nowrap;
                  }
                }
                .formkit-file-remove{
                  @apply text-transparent py-0 w-10 h-10 absolute left-0 top-[6px] lg:top-3;
                  &::before{
                    content: url('@/assets/img/remove.svg');
                  }
                }
              }
              .formkit-file-remove{
                @apply ml-2 text-xl text-ore_green_dark py-4;
              }
            }
          }
          .formkit-messages{
            @apply text-red-500 text-base pl-3 pt-1;
          }
          .formkit-help{
            @apply text-ore_green text-[14px] pl-3 pt-1;
          }
        }
        .formkit-outer[data-type="checkbox"]{
          @apply md:basis-full;
          .formkit-wrapper {
            @apply flex-row justify-start items-center mt-4;
            .formkit-inner {
              @apply max-w-max;
              .formkit-input{
                @apply max-w-max cursor-pointer;
              }
              input.formkit-input{
                @apply rounded-[100px] bg-cover bg-transparent lg:mr-4;
                background-image: url('@/assets/img/checkbox-unchecked.svg');
              }
              input.formkit-input:checked{
                @apply bg-auto;
                background-image: url('@/assets/img/checkbox-checked.svg');
              }
            }
            .formkit-label{
              @apply my-0 border-t-0 py-0 leading-6 cursor-pointer;
            }
          }
        }
        .formkit-outer[data-type="select"]{
          .formkit-wrapper{
            .formkit-inner{
              select.formkit-input {
                @apply bg-auto;
                background-image: url('@/assets/img/down-circle-arrow-orange.svg');
              }
            }
          }
        }
      }

      .step-content-container {
        @apply w-full flex flex-col py-4 md:py-12 desktop:py-14;
        .step-content {
          @apply flex flex-col md:flex-row md:flex-wrap w-full;
          .validation-errors {
            @apply bg-red-200 text-red-500 rounded-2xl p-4 mt-2;
          }
          .formkit-outer{
            @apply flex flex-col w-full lg:basis-2/4 mb-2;
            &.half-width{
              @apply basis-2/4;
            }
            &:nth-of-type(even){
              @apply md:basis-[48%] mr-[2%];
            }
            &:nth-of-type(odd), &.always-full ~ .half-width:nth-of-type(even){
              @apply lg:basis-[48%] lg:mr-[2%];
            }

            &.always-full {
              @apply md:basis-full lg:basis-full;
              .formkit-wrapper{
                @apply lg:w-[48%];
                .formkit-label {
                  @apply w-1/2 lg:w-full;
                }
              }
            }
            .formkit-wrapper {
              @apply w-full flex flex-col;
              .formkit-label{
                @apply text-ore_green font-FHOscar font-normal text-base leading-7 mt-4 lg:mt-5 py-1 ml-4 lg:ml-0 border-t-0 w-auto;
              }
              .formkit-inner{
                @apply flex flex-col w-full;
                  &:focus-visible, &:focus {
                  --tw-ring-shadow: none;
                  @apply border-none outline-none shadow-none;
                }

                .formkit-input {
                  @apply flex w-full border-none text-ore_green p-3 rounded-xl font-FHOscar font-normal text-base leading-7;

                  &:focus-visible, &:focus {
                    --tw-ring-shadow: none;
                    @apply border-none outline-none shadow-none;
                  }

                  &[type="date"]{
                    @apply cursor-pointer;
                  }

                  &[type="file"]{
                    @apply text-transparent flex items-center justify-center pl-2 leading-none;

                    &::-webkit-file-upload-button {
                      @apply invisible;
                    }

                    &::before {
                      content: "Attach File";
                      -webkit-user-select: none;
                      @apply flex items-center justify-center text-white bg-ore_orange rounded-[100px] outline-none whitespace-nowrap cursor-pointer text-base lg:text-lg py-1 px-6 lg:px-8 w-36 lg:w-44;
                    }
                  }
                }

                select {
                  @apply cursor-pointer;
                }

                .formkit-no-files{
                  @apply pl-2;
                }

                .formkit-file-list{
                  @apply flex flex-col lg:flex-row lg:flex-wrap gap-y-1 lg:gap-x-1 pl-2 lg:pl-0;

                  .formkit-file-item{
                    @apply flex flex-row-reverse items-center justify-center bg-ore_green text-white rounded-[100px] text-lg lg:text-xl leading-10 py-1 lg:py-4 px-6 lg:px-20 gap-x-8 relative;
                    .formkit-file-name {
                      @apply inline-block text-ellipsis max-w-full overflow-hidden whitespace-nowrap;
                    }
                  }
                  .formkit-file-remove{
                    @apply text-transparent py-0 w-10 h-10 absolute left-0 top-[6px] lg:top-3;
                    &::before{
                      content: url('@/assets/img/remove.svg');
                    }
                  }
                }

                .formkit-file-remove{
                  @apply ml-2 text-xl text-ore_green_dark py-4;
                }
              }
            }
            .formkit-messages{
              @apply text-red-500 text-base pl-3 pt-1;
            }

            .formkit-help{
              @apply text-ore_green text-[14px] pl-3 pt-1;
            }
          }
          .formkit-input[type="hidden"] ~ .formkit-outer:nth-of-type(odd):not([data-type="checkbox"]):not(.always-full){
            @apply lg:basis-2/4 lg:mr-0;
          }
          .formkit-outer[data-type="checkbox"] ~ .formkit-outer:nth-of-type(even){
            @apply md:basis-full md:mr-0 lg:basis-[48%] lg:mr-[2%];
          }
          .formkit-outer[data-type="checkbox"]{
            @apply md:basis-full;
            .formkit-wrapper {
              @apply flex-row justify-start items-center mt-4;
              .formkit-inner {
                @apply max-w-max;
                .formkit-input{
                  @apply max-w-max cursor-pointer;
                }
                input.formkit-input{
                  @apply rounded-[100px] bg-cover bg-transparent lg:mr-4;
                  background-image: url('@/assets/img/checkbox-unchecked.svg');
                }
                input.formkit-input:checked{
                  @apply bg-auto;
                  background-image: url('@/assets/img/checkbox-checked.svg');
                }
              }
              .formkit-label{
                @apply my-0 border-t-0 py-0 leading-6 cursor-pointer;
              }
            }
          }
          .formkit-outer[data-type="select"]{
            .formkit-wrapper{
              .formkit-inner{
                select.formkit-input {
                  @apply bg-auto;
                  background-image: url('@/assets/img/down-circle-arrow-orange.svg');
                }
              }
            }
          }
        }
      }
    }
  }
  .empty-cart-container {
    @apply h-[600px] rounded-3xl p-10 md:p-20 bg-white flex flex-col justify-center relative;
    h1 {
      @apply text-3xl leading-tight lg:text-[120px] text-ore_green mb-32;
    }

    .links {
      @apply flex flex-col md:flex-row;
      .nav-links {
        @apply text-[24px] text-ore_green relative mr-16 w-max underline;
        &:not(:first-child) {
          @apply ml-0 md:ml-12;
        }
        &::before {
          @apply content-[''] absolute border border-solid border-ore_green rounded-full h-2 w-2 -right-8 top-4 pointer-events-none;
        }
        &:not(:last-child)::after {
          @apply content-none md:content-[''] absolute border-r border-solid border-ore_orange h-16 w-1 -right-20 -top-3 pointer-events-none;
        }
      }
    }
  }

  .carousel-container {
      @apply flex flex-row py-5 gap-5 flex-wrap md:flex-nowrap;
      .related-products-title {
        @apply text-ore_orange text-[40px] my-10;
      }
      .carousel-card {
        @apply w-[47%] sm:w-[48%] md:w-4/12 min-h-[200px] sm:min-h-[285px] lg:min-h-[485px] overflow-hidden relative;
        &::before {
          @apply bg-white rounded-2xl content-[""] overflow-hidden absolute w-full h-full z-1 top-0 transition-transform duration-300 ease-in-out;
        }
        &:hover {
          .product-carousel-image {
            @apply transform scale-110 transition-transform duration-300 ease-in-out;
          }
          &:before {
            @apply transform scale-95 transition-transform duration-300 ease-in-out;
          }

          p {
            @apply transform translate-x-3 -translate-y-3 transition-transform duration-300 ease-in-out;
          }
        }
        .carousel-card-link {
          @apply z-2 flex flex-col items-center justify-between p-8 h-full;
          .product-carousel-image {
            @apply object-contain w-[525px] transition-transform duration-300 ease-in-out z-2 rounded-full;
          }
          p {
            @apply text-center self-start z-2 transition-transform duration-300 ease-in-out;
          }
        }
      }
    }
}
</style>

<style lang="scss">
/* Retail modal — not scoped so Teleport renders outside component root */
.retail-modal-overlay {
  @apply fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm px-4;
}

.retail-modal {
  @apply rounded-3xl max-w-2xl w-full overflow-hidden shadow-2xl;

  &__header {
    @apply bg-ore_green px-10 py-8 text-center;
  }

  &__title {
    @apply font-FHOscar font-medium text-3xl md:text-4xl leading-tight text-white;
  }

  &__body {
    @apply bg-white px-8 py-8 grid grid-cols-2 gap-4;
  }

  &__col {
    @apply flex flex-col gap-4 justify-between border border-ore_green/20 rounded-2xl p-6;
  }

  &__body-primary {
    @apply font-FHOscar font-medium text-base leading-7 text-ore_green;
  }

  &__body-secondary {
    @apply font-FHOscar font-normal text-base leading-7 text-ore_green/70;
  }

  &__body-note {
    @apply font-FHOscar font-normal text-sm leading-5 text-ore_green/40;
  }

  &__btn {
    @apply font-FHOscar font-medium text-base leading-6 rounded-3xl py-3 px-7 text-center transition-all duration-300 cursor-pointer;

    &--primary {
      @apply bg-ore_green text-white;
      &:hover { @apply opacity-90; }
    }

    &--secondary {
      @apply text-ore_orange;
      background-color: #e8e8e8;
      &:hover { @apply opacity-80; }
    }
  }
}
</style>
